module.exports = __webpack_public_path__ + "img/other-order@2x.c6e35370.png";